import React from "react";
import { Link } from "react-router-dom";
import {
  ArrowRight,
  Megaphone,
  Palette,
  LayoutTemplate,
  Bot,
  MessageCircle,
  Kanban,
  ListTodo,
  RefreshCcw,
  Gauge,
  BarChart3,
  Headphones,
  Wrench,
} from "lucide-react";

const INCLUDED = [
  { Icon: Megaphone,      label: "Meta Advertising Strategy & Management" },
  { Icon: Palette,        label: "Exterior-Cleaning Ad Creative & Copy" },
  { Icon: LayoutTemplate, label: "Service-Specific Landing Pages" },
  { Icon: Bot,            label: "LEO AI Follow-Up & Qualification" },
  { Icon: MessageCircle,  label: "Automated SMS & Email Follow-Up" },
  { Icon: Kanban,         label: "7FC Job Hub" },
  { Icon: ListTodo,       label: "Simple Lead & Quote Pipeline" },
  { Icon: RefreshCcw,     label: "Lost-Enquiry Reactivation" },
  { Icon: Gauge,          label: "Campaign Optimisation" },
  { Icon: BarChart3,      label: "Performance Reporting" },
  { Icon: Headphones,     label: "Direct Support From Chris" },
];

const System = () => {
  return (
    <section id="system" className="scroll-mt-20 bg-gray-50 py-14 sm:py-20">
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="mb-8 max-w-2xl sm:mb-12">
          <p className="mb-3 inline-flex items-center gap-2 rounded-full bg-brand-blue/10 px-3.5 py-1.5 text-xs font-black uppercase tracking-widest text-brand-blue">
            <Wrench className="h-3.5 w-3.5" /> The Complete System
          </p>
          <h2 className="text-3xl font-black uppercase leading-tight tracking-tight text-brand-black sm:text-4xl">
            Your Complete <span className="text-brand-blue">Exterior Cleaning</span> Job Pipeline.
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-brand-grayMid sm:text-base">
            We do more than run ads. We install a complete customer-acquisition and follow-up system designed
            to help you generate, manage and convert more local exterior-cleaning opportunities.
          </p>
        </div>

        {/* Bento grid — mobile 1 col (full-width tiles), desktop 3 cols */}
        <div className="grid auto-rows-fr grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 lg:grid-cols-3">
          {INCLUDED.map(({ Icon, label }) => (
            <div
              key={label}
              className="group flex items-start gap-3 rounded-3xl bg-white p-4 shadow-sm ring-1 ring-gray-200 transition-all hover:-translate-y-0.5 hover:shadow-md hover:ring-brand-blue/30 sm:p-5"
            >
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-brand-blue/10 text-brand-blue ring-1 ring-brand-blue/20">
                <Icon className="h-5 w-5" />
              </span>
              <div className="flex flex-1 items-center">
                <h3 className="text-sm font-black uppercase leading-snug tracking-tight text-brand-black sm:text-[15px]">
                  {label}
                </h3>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col items-start gap-3 sm:mt-10 sm:flex-row sm:items-center">
          <Link
            to="/offer"
            className="inline-flex min-h-[56px] items-center justify-center gap-2 rounded-2xl bg-brand-blue px-7 py-4 text-sm font-black uppercase tracking-wider text-white shadow-xl shadow-blue-200/60 ring-1 ring-blue-700/10 transition-all hover:bg-blue-600 active:scale-[0.99]"
          >
            Check If My Territory Is Available <ArrowRight className="h-5 w-5" />
          </Link>
          <span className="text-xs font-black uppercase tracking-widest text-brand-grayMid">
            All of the above included · $250 / week + GST
          </span>
        </div>
      </div>
    </section>
  );
};

export default System;
